import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import {LazyLoadImage} from "react-lazy-load-image-component";
import Data from "../../../images/industries/healthcare-software/tek-help.png";

function Help(props) {
    return (
        <div className="help p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="help_content_banner">
                            <div className="example" data-text="Help">
                                <h1>How Can TekRevol Help You Solve the Challenge in a Software Development Project in Healthcare</h1>
                            </div>
                            <div className="help_content">
                                <p>TekRevol offers top-tier assistance in designing and developing multiple solutions and services for healthcare software. By partnering with us, you can successfully integrate into the digital ecosystem and manage the data accurately.</p>
                                <p>We empower companies with leading transformative solutions and data-driven insights. Talk to our experts and learn about the latest healthcare technologies and how your business can benefit from them today!</p>
                                <Link to="/contact"
                                      className="border_btn" aria-label="TekRevol Contact">Let’s Connect!</Link>
                            </div>

                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
                        <LazyLoadImage
                            src={Data}
                            effect="blur" alt="Tab_01" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Help;